import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Seus links',
  subtitle:
    'Links e cupons rastreáveis criados pela equipe Bodyprint. Só números agregados, nunca quem se cadastrou.',
  period: 'Período',
  lastDays: {
    one: 'Último dia',
    other: 'Últimos {{count}} dias',
  },
  linksTitle: {
    one: '{{count}} link',
    other: '{{count}} links',
  },
  loadError: 'Não foi possível carregar seus links',
} satisfies TranslationTree;
